// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Children, cloneElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Section from '../Section';

import '../../helpers/base.less';
import './SwitchesPanel.less';

/**
 * `SwitchesPanel` component.
 * Used to organize [SwitchesPanelItem](#!/SwitchesPanelItem) components with responsive section layout.
 * Inherits properties of [Section](#!/Section) component.
 */
const SwitchesPanel = ({ baseClassName, className, children, ...props }) => (
    <Section className={classNames(baseClassName, className)} {...props}>
        <div className={`${baseClassName}__items`}>
            {children && Children.map(children, child => (
                cloneElement(child, {
                    className: classNames(child.props.className, `${baseClassName}__item`),
                })
            ))}
        </div>
    </Section>
);

SwitchesPanel.propTypes = {
    /**
     * Content of the `SwitchesPanel`. Recommended to use [SwitchesPanelItem](#!/SwitchesPanelItem) components.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

SwitchesPanel.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}switches-panel`,
};

export default SwitchesPanel;



// WEBPACK FOOTER //
// ./components/SwitchesPanel/SwitchesPanel.js